<template>
  <span class="badge" :class="['badge--theme-' + theme, 'badge--align-' + iconPlacement, `badge--type-${type}`]">
    <span>
      <slot>{{ value }}</slot>
    </span>
    <FontAwesomeIcon v-if="iconComp" v-bind="iconComp" />
  </span>
</template>

<script>
import { IconBinding } from '@/utils'

export default {
  props: {
    theme: {
      type: String,
      default: 'default',
    },
    type: {
      type: String,
      default: 'default',
      validator(val) {
        return ['default', 'outlined', 'filled'].includes(val)
      },
    },
    icon: [Object, String, Array],
    iconPlacement: {
      type: String,
      default: 'right',
      enum: ['right', 'left'],
    },
    value: {
      type: [String, Number],
      default() {
        if (this.theme === 'new') return this.$t('new')
      },
    },
  },
  computed: {
    iconComp() {
      if (!this.icon) return
      return IconBinding(this.icon)
    },
  },
}
</script>

<style lang="scss">
.badge {
  display: inline-flex;
  align-items: center;
  border-radius: 1rem;
  font-size: 0.8em;
  padding: 2px 7px;

  $states: (
    default: 'grey',
    primary: 'primary',
    secondary: 'secondary',
    warning: 'warning',
    success: 'dark-green',
    error: 'error',
    new: 'error',
  );

  &--align-left {
    flex-direction: row-reverse;

    svg {
      margin-left: 0;
      margin-right: 0.5em;
    }
  }

  svg {
    margin-left: 0.5em;
  }

  @each $name, $key in $states {
    &--type-default {
      &.badge--theme-#{$name} {
        color: hsl(var(--#{$key}-h), var(--#{$key}-s), 20%);
        background-color: hsl(var(--#{$key}-h), var(--#{$key}-s), 95%);
        border: 1px solid hsl(var(--#{$key}-h), var(--#{$key}-s), 85%);
      }
    }

    &--type-outlined {
      &.badge--theme-#{$name} {
        color: hsl(var(--#{$key}-h), var(--#{$key}-s), 20%);
        border: 1px solid var(--#{$key});
      }
    }

    &--type-filled {
      &.badge--theme-#{$name} {
        color: var(--#{$key}-contrast);
        background-color: var(--#{$key});
        border: 1px solid var(--#{$key});
      }
    }
  }
}
</style>
